export default __webpack_public_path__ + "120ebdcdb665d7456e1dd950a373597d.ttf";